// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { LoadingSpinnerStyle } from "@insite/mobius/LoadingSpinner";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { getProp } from "@insite/mobius/utilities";
import { headerStyles } from "@vanmeter/Overrides/Pages/Header";
import { DivWrapper } from "@vanmeter/XDL/constants";
import { color, companyLogoItem, layoutContainer, xScreen } from "@vanmeter/XDL/Utilities";
import { css } from "styled-components";

headerStyles.page = {
    fullWidth: [true, true, true, true, true],
    padding: 0,
    css: css`
        top: 0;
        z-index: ${getProp("theme.zIndex.header")};
        box-shadow: 0 1px 0 0 ${color("common.border")};

        ${xScreen("lte", "sm")} {
            overflow: unset;
        }

        ${xScreen("gt", "lg")} {
            position: sticky;
        }

        ${({ isCheckout }: any) =>
            isCheckout &&
            css`
                position: sticky;
                background-color: ${color("primary")};
            `}

        ${LoadingSpinnerStyle} {
            display: none;
        }
    `,
};

headerStyles.container = {
    css: css`
        display: flex;
        flex-direction: column;
        position: relative;
        ${xScreen("lte", "md")} {
            flex-direction: row-reverse;
            align-items: center;
            gap: 16px;
            background-color: ${color("primary")};
            ${layoutContainer}
        }
    `,
};

headerStyles.topSection = {
    css: css`
        padding: 8px 0;
        background-color: ${color("common.ui14")};

        ${xScreen("lte", "md")} {
            display: none;
        }
    `,
};

headerStyles.middleSectionWrapper = {
    css: css`
        width: 100%;
        background-color: ${color("primary")};
    `,
};

headerStyles.middleSection = {
    css: css`
        display: flex;
        justify-content: space-between;
        align-items: center;
        gap: 16px;
        ${xScreen("gt", "lg")} {
            ${layoutContainer}
        }
    `,
};

headerStyles.logo = {
    css: css`
        ${({ isCheckout }: any) =>
            isCheckout
                ? css`
                      padding-block: 0;
                  `
                : css`
                      padding-block: 12px;
                      margin-right: 16px;
                      ${xScreen("lte", "md")} {
                          padding-block: 8px;
                          margin-right: 0;
                      }
                  `}
    `,
};

headerStyles.search = {
    css: css`
        flex: 1;
        /* XNG-Change: layout shift */
        min-height: 44px;

        ${xScreen("lte", "md")} {
            flex: unset;
            padding: 8px 16px;
            min-height: unset;
        }
    `,
};

headerStyles.actions = {
    css: css`
        justify-self: end;

        > ${DivWrapper} {
            display: flex;
            align-items: center;
            justify-content: flex-end;
            ${xScreen("lte", "md")} {
                gap: 16px;
            }
        }
    `,
};

headerStyles.mainNavigation = {
    css: css`
        width: 100%;
        background-color: ${color("common.ui1")};
        ${xScreen("lte", "md")} {
            background-color: transparent;
            width: fit-content;
        }
    `,
};

headerStyles.checkoutWrapper = {
    css: css`
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        gap: 16px;
        padding-block: 8px;

        .list-wrapper {
            ${TypographyStyle} {
                color: ${color("common.ui1")};
                &:hover {
                    color: ${color("common.ui19")};
                }
            }
        }

        .wrapper:has(.home-page-link) {
            width: 112px;
            height: 38px;
        }
        ${layoutContainer}
    `,
};

headerStyles.printLogo = companyLogoItem;

headerStyles.printLogoImage = {
    css: css`
        max-width: 132px;
        max-height: 44px;
    `,
};
